import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { OfferCategory } from '@cds/betting-offer';
import { CompetitionRouteService } from '@frontend/sports/competition-list/feature';
import { EventListService } from '@frontend/sports/event-list/feature';
import { assign } from 'lodash-es';
import { map } from 'rxjs';

import { FixtureList } from '../../competition-list/competition.models';

export const dynamicOfferCategoriesResolver: ResolveFn<FixtureList> = (route: ActivatedRouteSnapshot) => {
    const router = inject(CompetitionRouteService);
    const eventListService = inject(EventListService);

    const params = router.params();

    const empty: FixtureList = {
        fixtures: [],
        totalCount: 0,
        params,
    };

    return eventListService.getFixtureList(params).pipe(
        // EventListComponent sets display based on marketOffer (old outright/special)
        map((result) => {
            const offerCategories = result?.fixtures.flatMap((f) =>
                f.optionMarkets.map((g) => g.templateCategory.category).concat(f.games.map((g) => g.templateCategory.category)),
            );

            const nonGridCategory = offerCategories?.find((oc) => oc === OfferCategory.Outrights || oc === OfferCategory.Specials);

            params.marketOffer = nonGridCategory ? nonGridCategory.toLowerCase() : 'matches';

            return assign(empty, result);
        }),
    );
};
